module.exports = __webpack_public_path__ + "static/img/to_share.5268f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/to_share.png
// module id = QfCZ
// module chunks = 1